import React from "react";
import {Helmet} from "react-helmet";
import {MichaelIsles} from "../../constants/meta";

export const A32Meta = () => (
    <Helmet>
            <title>Willis Designs | Vieunite </title>
        <meta name="twitter:card" value="summary"/>
        <meta name="twitter:site" value="@VieuniteHQ"/>
        <meta name="twitter:title" value="Vieunite Artist | Willis Designs"/>
        <meta name="twitter:description"
              content=". He is an advocate for art in all its glorious diversity and believes whole-heartedly in the power of creativity to bring positive change wherever it lands. "/>
        <meta name="twitter:image" value="https://vieunite.com/images/vieunite_sc_willis_designs.jpg"/>
        <meta property="og:type" content="website"/>
        <meta property="og:title" content="Vieunite Artist | Willis Designs"/>
        <meta property="og:description"
              content=" He is an advocate for art in all its glorious diversity and believes whole-heartedly in the power of creativity to bring positive change wherever it lands. "/>
        <meta property="og:image" content="https://vieunite.com/images/vieunite_sc_ willis_designs.jpg"/>


    </Helmet>);